import { environment } from '../environments/environment';
export const API_URL = environment.BACKEND_URL;


// WEBPACK FOOTER //
// /app/src/app/config.ts